module.exports = __webpack_public_path__ + "img/DNI-ALLARIA-Frente.02af9b44.jpg";